 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~49f767f8":"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~49f767f8","default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~8b52c348":"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~8b52c348","default~bank-bank-module~main-pages-pages-module~nomina-aprobar-nomina-aprobar-nomina-module~nomina-~54fbb9be":"default~bank-bank-module~main-pages-pages-module~nomina-aprobar-nomina-aprobar-nomina-module~nomina-~54fbb9be","default~bank-bank-module~main-pages-pages-module~nomina-banco-envio-banco-envio-module~pages-authent~56e2b27c":"default~bank-bank-module~main-pages-pages-module~nomina-banco-envio-banco-envio-module~pages-authent~56e2b27c","default~main-pages-pages-module~pages-authentication-mfa-setup-mfa-setup-module":"default~main-pages-pages-module~pages-authentication-mfa-setup-mfa-setup-module","main-pages-pages-module":"main-pages-pages-module","main-apps-apps-module":"main-apps-apps-module","default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~a9683d58":"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~a9683d58","default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~a4f09255":"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~a4f09255","default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~5923d562":"default~admin-comercio-comercio-module~admin-comercios-comercios-module~admin-grupos-grupos-module~a~5923d562","default~admin-comercio-comercio-module~admin-usuarios-usuarios-module~balance-principal-balance-bala~8641ce59":"default~admin-comercio-comercio-module~admin-usuarios-usuarios-module~balance-principal-balance-bala~8641ce59","default~admin-comercio-comercio-module~admin-comercios-comercios-module":"default~admin-comercio-comercio-module~admin-comercios-comercios-module","admin-comercio-comercio-module":"admin-comercio-comercio-module","default~balance-principal-balance-balance-module~balance-principal-balance-detail-balance-detail-mod~4a892806":"default~balance-principal-balance-balance-module~balance-principal-balance-detail-balance-detail-mod~4a892806","default~nomina-error-nomina-error-nomina-module~nomina-nominas-nominas-module":"default~nomina-error-nomina-error-nomina-module~nomina-nominas-nominas-module","nomina-error-nomina-error-nomina-module":"nomina-error-nomina-error-nomina-module","default~admin-comercios-comercios-module~admin-grupos-grupos-module~admin-rates-rates-module~admin-r~049dce9b":"default~admin-comercios-comercios-module~admin-grupos-grupos-module~admin-rates-rates-module~admin-r~049dce9b","admin-grupos-grupos-module":"admin-grupos-grupos-module","admin-rates-rates-module":"admin-rates-rates-module","admin-roles-roles-module":"admin-roles-roles-module","common":"common","nomina-banco-cargar-constancia-banco-cargar-constancia-module":"nomina-banco-cargar-constancia-banco-cargar-constancia-module","admin-comercios-comercios-module":"admin-comercios-comercios-module","admin-usuarios-usuarios-module":"admin-usuarios-usuarios-module","reportes-reporte-descargable-reporte-descargable-module":"reportes-reporte-descargable-reporte-descargable-module","reportes-reporte-detalle-reporte-detalle-module":"reportes-reporte-detalle-reporte-detalle-module","balance-principal-balance-detail-balance-detail-module":"balance-principal-balance-detail-balance-detail-module","balance-principal-balance-fechas-balance-fechas-module":"balance-principal-balance-fechas-balance-fechas-module","balance-principal-balance-hoy-balance-hoy-module":"balance-principal-balance-hoy-balance-hoy-module","balance-principal-balance-balance-module":"balance-principal-balance-balance-module","default~bank-bank-module~dashboards-project-project-module":"default~bank-bank-module~dashboards-project-project-module","dashboards-project-project-module":"dashboards-project-project-module","nomina-banco-actualizar-estado-banco-actualizar-estado-module":"nomina-banco-actualizar-estado-banco-actualizar-estado-module","nomina-banco-respuesta-manual-detalle-banco-respuesta-manual-detalle-module":"nomina-banco-respuesta-manual-detalle-banco-respuesta-manual-detalle-module","reportes-reporte-operativo-reporte-operativo-module":"reportes-reporte-operativo-reporte-operativo-module","reportes-reporte-reporte-module":"reportes-reporte-reporte-module","default~nomina-detalle-nomina-detalle-nomina-module~nomina-nominas-nominas-module":"default~nomina-detalle-nomina-detalle-nomina-module~nomina-nominas-nominas-module","nomina-detalle-nomina-detalle-nomina-module":"nomina-detalle-nomina-detalle-nomina-module","default~bank-bank-module~nomina-banco-envio-banco-envio-module~nomina-banco-respuesta-agrupacion-ban~c86e2a70":"default~bank-bank-module~nomina-banco-envio-banco-envio-module~nomina-banco-respuesta-agrupacion-ban~c86e2a70","nomina-banco-respuesta-agrupacion-banco-respuesta-agrupacion-module":"nomina-banco-respuesta-agrupacion-banco-respuesta-agrupacion-module","nomina-banco-respuesta-banco-respuesta-module":"nomina-banco-respuesta-banco-respuesta-module","default~bank-bank-module~nomina-banco-envio-banco-envio-module":"default~bank-bank-module~nomina-banco-envio-banco-envio-module","nomina-banco-envio-banco-envio-module":"nomina-banco-envio-banco-envio-module","nomina-nominas-nominas-module":"nomina-nominas-nominas-module","nomina-aprobar-nomina-aprobar-nomina-module":"nomina-aprobar-nomina-aprobar-nomina-module","nomina-banco-nomina-detalle-banco-nomina-detalle-module":"nomina-banco-nomina-detalle-banco-nomina-detalle-module","nomina-banco-respuesta-manual-banco-respuesta-manual-module":"nomina-banco-respuesta-manual-banco-respuesta-manual-module","pages-authentication-mfa-setup-mfa-setup-module":"pages-authentication-mfa-setup-mfa-setup-module","admin-profile-profile-module":"admin-profile-profile-module","dashboards-analytics-analytics-module":"dashboards-analytics-analytics-module","default~bank-bank-module~nomina-carganomina-carganomina-module":"default~bank-bank-module~nomina-carganomina-carganomina-module","nomina-carganomina-carganomina-module":"nomina-carganomina-carganomina-module","bank-bank-module":"bank-bank-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
